module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8mlhqk/images/cover.jpg?1688985128503",
      "alt": "This image is the cover for the book Oswego Township, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Oswego Township, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In 1832, John, Walter, and Daniel Pearce, and their brother-in-law, William Smith Wilson, walked west from their homes in Ohio prospecting for land. When they reached the Fox River in the vicinity of modern Oswego, they agreed they had found the place they wanted to settle. The next year, 1833, after selling their Ohio farms, they traveled west by wagon with their families and became the first settlers in Oswego Township. Just two years later, Lewis B. Judson and Levi F. Arnold laid out a new village on land first claimed by Wilson, creating the foundation of today�s bustling village of Oswego. A stagecoach route crossroads, the seat of Kendall"), _c('br'), _vm._v("County for nearly 20 years, and a market town for the surrounding agricultural area, Oswego grew steadily until the Civil War. After the war, growth slowed until the second half of the 20th century when the area began to boom, both in population and economically. This book offers many of the area�s newest residents a chance to look back at Oswego Township�s rich heritage.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      , Roger Matile\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Photographs for this volume were selected by editor Roger Matile from the collections of the Little White School Museum, maintained by the Oswegoland Heritage Association, with the help of museum volunteers.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0